
export const HTML_IDS = {
  // iframe with explicit zIndex
  googleMerchantWidget: 'merchantwidgetiframe',

  // div with explicit zIndex
  livechatWidget: 'chat-widget-container'
}

export const ZINDEXES = {
  slightlyElevated: 100, // repositioned google merchant center

  shadeOverlay: 1000,
  groupGridSidebar: 2000,
  dropdownMenu: 2000,
  showCustomerVehicle: 2100, // pulldown vehicle selector at top of NOLA navbar
  hamburgerMenu: 200_000,
  // modal stuff
  pulsingLinesThrobber: 500_000,
  modalFadeScreen: 500_010,
  // liveChatWidget: 1_000_000,
  // absurdly high numbers

  // claimed by livechat: 2147483639
  // claimed by google trusted stores: 2147483647
  MAXIMUM: 2_147_483_647
}
